// import Full from 'Container/Full'
import HorizontalLayout from 'Container/HorizontalLayout'

// dashboard components
const Ecommerce = () => import('Views/dashboard/Ecommerce')

// Prescripciones views
const Prescripciones = () => import('Views/prescripciones/Prescripciones')

// Direccionamientos views
const Direccionamientos = () => import('Views/direccionamientos/Direccionamientos')

// Programaciones views
const Programaciones = () => import('Views/programaciones/Programaciones')

// Entregas views
const Entregas = () => import('Views/entregas/Entregas')

// Reportes de entrega views
const ReportesEntrega = () => import('Views/reportesEntrega/ReportesEntrega')

// Mipres vies
const Mipres = () => import('Views/mipres/Processes')

// Facturación vies
const Facturacion = () => import('Views/facturacion/Facturacion')

// Administrativo
// layout
const Administrativo = () => import('Views/administrativo/layout/Layout')
//información empresa
const InformacionEmpresa = () => import('Views/administrativo/views/empresa/InformacionEmpresa')
// users
const UsersList = () => import('Views/administrativo/views/users/UsersList')
const Roles = () => import('Views/administrativo/views/roles/Roles')
// Sedes
const Sedes = () => import('Views/administrativo/views/sedes/SedesList')
// Facturas
const Facturas = () => import('Views/administrativo/views/facturas/Facturas')

// Precios
const Precios = () => import('Views/administrativo/views/precios/Precios')

// Reportes vies
const Reportes = () => import('Views/reportes/Reportes')
export default {
   path: '/',
   component: HorizontalLayout,
   redirect: '/default/dashboard/ecommerce',
   children: [
      {
         path: '/default/dashboard/ecommerce',
          name: 'Dashboard',
          component: Ecommerce,
          meta: {
              requiresAuth: true,
              pageTitle: {
                  avatar: {
                      icon: 'zmdi zmdi-balance',
                      color: 'primary',
                  },
                  title: 'MIPRES',
                  subTitle: 'Procesos de gestión'
              }
          }
      },
       // Prescripciones
       {
           path: '/default/prescripciones/prescripciones',
           name: 'Prescripciones',
           component: Prescripciones,
           meta: {
               requiresPermission: 'prescripciones.show',
               requiresAuth: true,
               pageTitle: {
                   avatar: {
                       icon: 'ti ti-pencil-alt',
                       color: 'info',
                   },
                   title: 'Prescripciones',
                   subTitle: 'Registro y gestión'
               }
           }
       },
       // Direccionamientos
       {
           path: '/default/direccionamientos/direccionamientos',
           name: 'Direccionamientos',
           component: Direccionamientos,
           meta: {
               requiresPermission: 'direccionamientos.show',
               requiresAuth: true,
               pageTitle: {
                   avatar: {
                       icon: 'ti ti-direction-alt',
                       color: 'primary',
                   },
                   title: 'Direccionamientos',
                   subTitle: 'Registro y gestión'
               }
           }
       },
       // Programaciones
       {
           path: '/default/programaciones/programaciones',
           name: 'Programaciones',
           component: Programaciones,
           meta: {
               requiresPermission: 'programaciones.show',
               requiresAuth: true,
               pageTitle: {
                   avatar: {
                       icon: 'ti ti-timer',
                       color: 'purple',
                   },
                   title: 'Programaciones',
                   subTitle: 'Gestión'
               }
           }
       },
       // Entregas
       {
           path: '/default/entregas/entregas',
           name: 'Entregas',
           component: Entregas,
           meta: {
               requiresPermission: 'entregas.show',
               requiresAuth: true,
               pageTitle: {
                   avatar: {
                       icon: 'ti ti-package',
                       color: 'success',
                   },
                   title: 'Entregas',
                   subTitle: 'Gestión'
               }
           }
       },
      // Reportes de entrega
       {
           path: '/default/reportes-entrega/reportes-entrega',
           name: 'ReportesEntrega',
           component: ReportesEntrega,
           meta: {
               requiresPermission: 'reportesEntregas.show',
               requiresAuth: true,
               pageTitle: {
                   avatar: {
                       icon: 'ti ti-export',
                       color: 'info',
                   },
                   title: 'Reportes de entrega',
                   subTitle: 'Gestión'
               }
           }
       },
       // Administrativo
       {
           path: '/default/adminidtrativo',
           name: 'Administrativo',
           component: Administrativo,
           redirect: { name: 'Sedes' },
           children: [
               // Información empresa
               {
                   path: 'informacion-empresa',
                   name: 'InformacionEmpresa',
                   component: InformacionEmpresa,
                   meta: {
                       requiresPermission: 'empresa.show',
                       requiresAuth: true,
                       pageTitle: {
                           avatar: {
                               icon: 'fas fa-hospital-alt',
                               color: 'warning',
                           },
                           title: 'Información de empresa',
                           subTitle: 'Detalle'
                       }
                   }
               },
               // users
               {
                   path: 'usuarios',
                   name: 'Usuarios',
                   component: UsersList,
                   meta: {
                       requiresPermission: 'user.show',
                       requiresAuth: true,
                       pageTitle: {
                           avatar: {
                               icon: 'fas fa-users',
                               color: 'warning',
                           },
                           title: 'Usuarios',
                           subTitle: 'Registro y gestión'
                       }
                   }
               },
               // Roles
               {
                   path: 'roles',
                   name: 'Roles',
                   component: Roles,
                   meta: {
                       requiresPermission: 'roles.show',
                       requiresAuth: true,
                       pageTitle: {
                           avatar: {
                               icon: 'fas fa-cogs',
                               color: 'warning',
                           },
                           title: 'Roles',
                           subTitle: 'Registro y gestión'
                       }
                   }
               },
               // Sedes
               {
                   path: 'sedes',
                   name: 'Sedes',
                   component: Sedes,
                   meta: {
                       requiresPermission: 'sedes.show',
                       requiresAuth: true,
                       pageTitle: {
                           avatar: {
                               icon: 'fas fa-clinic-medical',
                               color: 'warning',
                           },
                           title: 'Sedes',
                           subTitle: 'Procesos de gestión'
                       }
                   }
               },
               // Pagos
               {
                   path: 'facturas',
                   name: 'Facturas',
                   component: Facturas,
                   meta: {
                       requiresPermission: 'facturas.show',
                       requiresAuth: true,
                       pageTitle: {
                           avatar: {
                               icon: 'fas fa-file-invoice-dollar',
                               color: 'warning',
                           },
                           title: 'Facturas',
                           subTitle: 'Historial de pagos'
                       }
                   }
               },
               // Precios
               {
                   path: 'precios',
                   name: 'Precios',
                   component: Precios,
                   meta: {
                       requiresPermission: 'precios.show',
                       requiresAuth: true,
                       pageTitle: {
                           avatar: {
                               icon: 'fas fa-money-check-alt',
                               color: 'warning',
                           },
                           title: 'Precios',
                           subTitle: 'Gestión'
                       }
                   }
               }
           ]
       },
       // MIPRES
       {
           path: '/default/mipres/processes',
           name: 'Mipres',
           component: Mipres,
           meta: {
               requiresPermission: 'mipres.show',
               requiresAuth: true,
               pageTitle: {
                   avatar: {
                       icon: 'zmdi zmdi-balance',
                       color: 'red',
                   },
                   title: 'MIPRES',
                   subTitle: 'Procesos de gestión'
               }
           }
       },
       // Facturación
       {
           path: '/default/facturacion/facturacion',
           name: 'Facturacion',
           component: Facturacion,
           meta: {
               requiresPermission: 'facturacion.show',
               requiresAuth: true,
               pageTitle: {
                   avatar: {
                       icon: 'fas fa-file-invoice-dollar',
                       color: 'primary',
                   },
                   title: 'Facturación',
                   subTitle: 'Gestión'
               }
           }
       },
       {
           path: '/default/reportes/reportes',
           name: 'Reportes',
           component: Reportes,
           meta: {
               requiresPermission: 'reportes.show',
               requiresAuth: true,
               pageTitle: {
                   avatar: {
                       icon: 'fas fa-file-excel',
                       color: 'green',
                   },
                   title: 'Reportes',
                   subTitle: 'Descargas'
               }
           }
       }
   ]
}
